export const CHANGE_PRISTINE_FORM = 'CHANGE_PRISTINE_FORM';

export const changePristineForm = ({ pristine }) => dispatch => (
    dispatch({
        type: CHANGE_PRISTINE_FORM,
        payload: { pristine },
    })
);
